import { render, staticRenderFns } from "./OtherList.vue?vue&type=template&id=5b76434e"
import script from "./OtherList.vue?vue&type=script&lang=js"
export * from "./OtherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports